import React, { useState, useContext, useEffect } from "react";
import { AuthContext } from "../auth/ContextAuthentication";
import { ErrorLoadingContext } from "../auth/ErrorLoadingContext";
import useAxiosConfig from "../config/AxiosConfig";
import { useLocation } from "react-router-dom";
import {
  Autocomplete,
  TextField,
  CircularProgress,
  Button,
  Pagination,
  MenuItem,
  FormControl,
  InputLabel,
  Select,
} from "@mui/material";
import TeamTable from "../component/TeamTable";

const Teams = () => {
  const axiosInstance = useAxiosConfig();
  const { teamData, setTeamData } = useContext(AuthContext);
  const [allBookingData, setAllBookingData] = useState([]);
  const { setLoading, setError } = useContext(ErrorLoadingContext);
  const [sports, setSports] = useState([]);
  const [grounds, setGrounds] = useState([]);
  const [selectedSport, setSelectedSport] = useState(null);
  const [selectedGround, setSelectedGround] = useState(null);
  const [groundMap, setGroundMap] = useState([]);
  const [isLoadingGrounds, setIsLoadingGrounds] = useState(false);
  const [isFetchingTeams, setIsFetchingTeams] = useState(false);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const { adminRole } = useContext(AuthContext);
  const [totalPages, setTotalPages] = useState(0);
  const [page, setPage] = useState(1);
  const [selectedApp, setSelectedApp] = useState("");
  const [isLoadingAllData, setIsLoadingAllData] = useState(false);
  const [city, setCity] = useState("");
  const [cityFilter, setCityFilter] = useState("");
  const [catagoryFilter, setCatagoryFilter] = useState("");

  useEffect(() => {
    fetchAllSports();
    fetchTeams();
  }, []);

  const headerData = [
    "Team Logo",
    "Team Name",
    "Sports Type",
    "City",
    "Category",
    "Coach Name",
    "Coach Phone",
    "Captain Name",
    "Captain Phone",
  ];

  const cityOptions = [
    { label: "All", value: "all" },
    { label: "Islamabad", value: "islamabad" },
    { label: "Lahore", value: "lahore" },
  ];

  const categoryOptions = [
    { label: "Male", value: "male" },
    { label: "Female", value: "female" },
  ];

  const handleCityFilterChange = (event, newValue) => {
    setCityFilter(newValue ? newValue.value : "All");
  };
  const handleCatagoryFilterChange = (event, newValue) => {
    setCatagoryFilter(newValue ? newValue.value : "All");
  };

  const fetchAllSports = async () => {
    setIsLoadingGrounds(true);
    try {
      const response = await axiosInstance.get("/api/ground/get-all-sports");
      const sports = response?.data?.data;
      setSports(sports);
      //   console.log("sports", sports);
    } catch (error) {
      setError("Error fetching sports");
    } finally {
      setIsLoadingGrounds(false);
    }
  };

  const fetchTeams = async () => {
    try {
      const baseUrl = "api/team-managment/explore-teams";

      // Create an object to store query parameters
      const queryParams = new URLSearchParams();

      // Add groundId parameter
      queryParams.append("city", city || "");

      // Add sportsId parameter
      queryParams.append("gender", selectedSport?._id || "");
      queryParams.append("sportsId", catagoryFilter || "");

      // Add date parameters if both exist
      //   if (startDate && endDate) {
      //     queryParams.append("startDate", startDate);
      //     // queryParams.append("endDate", endDate);
      //   }

      //   // Add page parameter
      //   queryParams.append("page", page);
      //   // queryParams.append("limit", limit);
      //   if (selectedApp) {
      //     queryParams.append(
      //       "fromMaidanApp",
      //       selectedApp === "Maidan App" ? true : false
      //     );
      //   }
      // Construct final URL
      const url = `${baseUrl}?${queryParams.toString()}`;
      setIsFetchingTeams(true);
      const response = await axiosInstance.get(url);
      //   console.log("response", response);
      setTeamData(response?.data?.data || []);
      //   setTotalPages(response.data.totalPages);
    } catch (error) {
      console.log("error", error);
      setError("Error fetching bookings");
      setTeamData([]);
    } finally {
      setIsFetchingTeams(false);
    }
  };

  const handlePageChange = (event, newPage) => {
    setPage(newPage);
  };

  return (
    <div className="p-4 w-full">
      <h2 className="text-xl font-bold mb-4">Teams</h2>
      <div className="mb-4 flex gap-4">
        <Autocomplete
          options={sports}
          getOptionLabel={(option) => option.name}
          style={{ width: 300 }}
          renderInput={(params) => (
            <TextField
              {...params}
              label="Select Sport"
              InputProps={{
                ...params.InputProps,
                endAdornment: (
                  <React.Fragment>
                    {isLoadingGrounds ? (
                      <CircularProgress color="inherit" size={20} />
                    ) : null}
                    {params.InputProps.endAdornment}
                  </React.Fragment>
                ),
              }}
            />
          )}
          onChange={(event, newValue) => {
            setSelectedSport(newValue);
            if (newValue) {
              //   fetchGroundsBySport(newValue._id);
            } else {
              setGrounds([]);
            }
          }}
          loading={isLoadingGrounds}
        />
        <Autocomplete
          options={cityOptions}
          getOptionLabel={(option) => option.label}
          style={{ width: 300 }}
          renderInput={(params) => (
            <TextField
              {...params}
              label="City"
              InputProps={{
                ...params.InputProps,
              }}
            />
          )}
          onChange={handleCityFilterChange}
          value={
            cityOptions.find((option) => option.value === cityFilter) || null
          }
        />
        <Autocomplete
          options={categoryOptions}
          getOptionLabel={(option) => option.label}
          style={{ width: 300 }}
          renderInput={(params) => (
            <TextField
              {...params}
              label="Category"
              InputProps={{
                ...params.InputProps,
              }}
            />
          )}
          onChange={handleCatagoryFilterChange}
          value={
            categoryOptions.find(
              (option) => option.value === categoryOptions
            ) || null
          }
        />
        <TextField
          label="Date Created"
          type="date"
          value={startDate}
          onChange={(e) => {
            // Check if this is a real user selection rather than month navigation
            if (e.target.value !== startDate) {
              setStartDate(e.target.value);
            }
          }}
          onClick={(e) => e.stopPropagation()} // Prevent event bubbling
          InputLabelProps={{ shrink: true }}
          style={{ width: 300 }}
        />
      </div>
      <TeamTable
        headerData={headerData}
        isLoading={isFetchingTeams}
        // groundMap={groundMap}
        // selectedApp={selectedApp}
      />
      <div className="w-[70%] mx-auto flex justify-center">
        <Pagination
          count={totalPages}
          page={page}
          onChange={handlePageChange}
        />
      </div>
    </div>
  );
};

export default Teams;
